import {
  type Breakpoint,
  breakpoints,
} from "@repo/fika-design-system/breakpoints"
import { cdnClass, type LogoClass } from "@repo/fika-design-system/cdnClass"
import { createMemo, createSignal, For, type JSXElement, Show } from "solid-js"
import { borderClass, logoClass, pictureClass, wrapperRecipe } from "./logo.css"

type Image = {
  url?: string | null
  imageClass: LogoClass
}
type AlternativeImage = Image & {
  breakpoint: Breakpoint
}
type Props = {
  image: Image
  srcset?: AlternativeImage[]
  alt: string
  fallback: JSXElement
}
export function Logo(props: Props) {
  const [mainImage, setMainImage] = createSignal<Image | null>(props.image)

  const types = createMemo(() => ({
    ...Object.fromEntries(
      props.srcset?.map(s => [s.breakpoint, s.imageClass]) || [],
    ),
    base: props.image.imageClass,
  }))

  return (
    <div class={wrapperRecipe({ ...types() })}>
      <Show when={mainImage()} fallback={props.fallback}>
        {mainImage => (
          <Show when={mainImage().url} fallback={props.fallback}>
            {url => (
              <picture class={pictureClass}>
                <For each={props.srcset || []}>
                  {img => (
                    <Show when={img.url}>
                      {url => (
                        <source
                          srcset={cdnClass(url(), img.imageClass)}
                          media={breakpoints[img.breakpoint]}
                        />
                      )}
                    </Show>
                  )}
                </For>
                <img
                  src={cdnClass(url(), mainImage().imageClass)}
                  loading="lazy"
                  alt={props.alt}
                  onError={() => {
                    setMainImage(null)
                  }}
                  class={logoClass}
                />
              </picture>
            )}
          </Show>
        )}
      </Show>
      <div class={borderClass} />
    </div>
  )
}
